module.exports = __webpack_public_path__ + "static/media/tap_ios.68fef63d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/svgs/tap_ios.svg
// module id = 368
// module chunks = 1